// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"6454":"Widgets","7051":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] || chunkId) + "." + {"6454":"d152a563","7051":"d152a563","8375":"c665a28e"}[chunkId] + ".chunk.css";
};